<main class="relative">
  <ng-container *ngIf="!Utility.showHeader">
    <div [innerHTML]="resetTopStyles" class="d-none"></div>
  </ng-container>
  <header *ngIf="Utility.showHeader" class="px-0 d-flex kp-header-shadow h-header"
    [class.dark-gray-bg]="mode=='employer'">
    <div class="flex-fill d-flex align-items-center justify-content-center">
      <a class="right-0 absolute pr-2" routerLink="/"><i class="fa fa-chevron-right"></i>صفحه اصلی</a>
      <a class="nav-brand mx-2 h-100 py-2" [routerLink]="logoLink">
        <img class="mh-100 mw-100" [src]="logo" [alt]="logoTitle" [title]="logoTitle">
      </a>
    </div>
  </header>
  <section class="white-bg relative p-0 h-min-full-header d-flex flex-column">
    <ngx-spinner [fullScreen]="false" type="timer"></ngx-spinner>
    <router-outlet></router-outlet>
  </section>
</main>